import React from "react"
import { ProSidebar, SidebarContent, SidebarFooter, Menu, MenuItem } from 'react-pro-sidebar'
import { Link } from 'react-router-dom'
import { MdMuseum } from 'react-icons/md'
import { GiHut } from 'react-icons/gi'
import { HiClipboardDocumentList } from 'react-icons/hi2'
import { MdVideoLibrary } from 'react-icons/md'
import { FaUsers } from 'react-icons/fa'
import { hasAdminPermissions, hasManagerPermissions } from '../utils/Auth'
import retold_logo from '../images/retold_logo_trans_240.png'

function Sidebar(props) {
    return (
        <ProSidebar breakPoint="md">
            <SidebarContent>
                <div className="title">
                    <span>RETOLD <span className="text-yellow"> PORTAL</span></span>
                </div>
                {!!props.currentUser &&
                    <Menu iconShape="circle">
                        {hasAdminPermissions(props.currentUser) && 
                            <MenuItem active={props.selectedItem === "museums"} icon={<MdMuseum />}>
                                <Link to={`/museums`}>Museums</Link>
                            </MenuItem>
                        }
                        <MenuItem active={props.selectedItem === "buildings"} icon={<GiHut />}>
                            <Link to={`/buildings`}>Buildings</Link>
                        </MenuItem>
                        <MenuItem active={props.selectedItem === "building-records"} icon={<HiClipboardDocumentList />}>
                            <Link to={`/building-records`}>Building Archive</Link>
                        </MenuItem>
                        <MenuItem active={props.selectedItem === "craft-records"} icon={<MdVideoLibrary />}>
                            <Link to={`/craft-records`}>Craft Archive</Link>
                        </MenuItem>
                        {hasManagerPermissions(props.currentUser) && 
                            <MenuItem active={props.selectedItem === "users"} icon={<FaUsers />}>
                                <Link to={`/users`}>Users</Link>
                            </MenuItem>
                        }
                    </Menu>
                }
            </SidebarContent>
            <SidebarFooter>
                <div>
                    <img src={retold_logo} />
                </div>
            </SidebarFooter>
        </ProSidebar>
    );
}
export default Sidebar